import {
  put,
  call
} from 'redux-saga/effects';
import {
  fetchHelpVidsSuccess,
  fetchHelpVidsFail,
  // addHelpVidFail,
  // addHelpVidSucccess,
  updateHelpVidSuccess,
  updateHelpVidFail,
  deleteHelpVidSuccess,
  deleteHelpVidFail
} from './actions';
import { parseApiError } from '../../util/api';
import HelpVidAPI from './HelpVidAPI';
import { showNotification } from '../../notifications/actions';

export function *fetchHelpVids () {
  try {
    const { data } = yield call(HelpVidAPI.fetchHelpVids);
    if (data && Array.isArray(data.helpVideos)) {
      yield put(fetchHelpVidsSuccess(data.helpVideos));
    } else {
      let msg = 'unexpected response fetching helpVids';
      yield put(fetchHelpVidsFail(msg));
      yield put(showNotification(
        'Failed to load help videos', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchHelpVidsFail(msg));
    yield put(showNotification(
      'Failed to load help videos', msg, 'error', 10
    ));
  }
}

// export function *addHelpVid (action) {
//   try {
//     yield call(HelpVidAPI.addHelpVid, action.helpVid);
//     yield put(addHelpVidSucccess(action.helpVid));
//     yield put(showNotification(
//       'Success', `video "${action.helpVid.title}" saved`, 'info', 5
//     ));
//   } catch (error) {
//     const msg = parseApiError(error);
//     yield put(addHelpVidFail(msg, action.helpVid));
//     yield put(showNotification(
//       `Failed to add help video "${action.helpVid.title}"`,
//       msg,
//       'error',
//       10
//     ));
//   }
// }

export function *updateHelpVid (action) {
  try {
    yield call(HelpVidAPI.updateHelpVid, action.helpVid);
    yield put(updateHelpVidSuccess(action.helpVid));
    yield put(showNotification(
      'Success', `video "${action.helpVid.title}" saved`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(updateHelpVidFail(msg, action.helpVid));
    yield put(showNotification(
      `Failed to update help video "${action.helpVid.title}"`,
      msg,
      'error',
      10
    ));
  }
}

export function *deleteHelpVid (action) {
  try {
    yield call(HelpVidAPI.deleteHelpVid, action.helpVid);
    yield put(deleteHelpVidSuccess(action.helpVid));
    yield put(showNotification(
      'Success', `video "${action.helpVid.title}" deleted`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(deleteHelpVidFail(msg, action.helpVid));
    yield put(showNotification(
      `Failed to delete help video "${action.helpVid.title}"`,
      msg,
      'error',
      10
    ));
  }
}
